import { UnitsManagementConst } from '@featureModule/units-management/consts';

/**
 * Constants for the Units sub-module within Units Management.
 * Provides route paths, translation keys, and API endpoint placeholders.
 */
export abstract class UnitsConst {

    /**
     * The display title for the Units page.
     */
    public static readonly TITLE = 'Units';

    /**
     * The i18n translation key for the Units sub-module.
     */
    public static readonly TRANSLATE_KEY = UnitsManagementConst.CHILDREN.UNITS.TRANSLATE_KEY();

    /**
     * The breadcrumb translation key for the Units page.
     */
    public static readonly BREADCRUMB = UnitsManagementConst.CHILDREN.UNITS.BREADCRUMB();

    /**
     * The URL route segment for the Units page.
     */
    public static readonly ROUTE_PAGE = UnitsManagementConst.CHILDREN.UNITS.ROUTE_PAGE;

    /**
     * The full absolute route link for the Units page.
     */
    public static readonly ROUTE_LINK = UnitsManagementConst.CHILDREN.UNITS.ROUTE_LINK();

    /** Base API endpoint prefix for Units requests. */
    public static readonly API_PREFIX_ENDPOINT = 'units';

    /** GET first-level units (direct children of the root). */
    public static readonly FIRST_LEVEL_ENDPOINT = `${UnitsConst.API_PREFIX_ENDPOINT}/first_level`;

    /** POST create a new unit. */
    public static readonly CREATE_ENDPOINT = `${UnitsConst.API_PREFIX_ENDPOINT}`;

    /** GET a single unit by ID. */
    public static readonly GET_BY_ID_ENDPOINT = (id: string): string => `${UnitsConst.API_PREFIX_ENDPOINT}/${id}`;

    /** GET direct children of a unit (lazy tree load). */
    public static readonly GET_CHILDREN_ENDPOINT = (id: string): string => `${UnitsConst.API_PREFIX_ENDPOINT}/${id}/get_units`;

    /** PUT update a unit by ID. */
    public static readonly UPDATE_ENDPOINT = (id: string): string => `${UnitsConst.API_PREFIX_ENDPOINT}/${id}`;

    /** DELETE a unit by ID. */
    public static readonly DELETE_ENDPOINT = (id: string): string => `${UnitsConst.API_PREFIX_ENDPOINT}/${id}`;

    /** GET flat dropdown list of all units (facility + buildings + sub-units). */
    public static readonly DROPDOWN_ENDPOINT = `${UnitsConst.API_PREFIX_ENDPOINT}/dropdown`;

    /**
     * GET the hierarchical unit tree rooted at the given unit ID.
     * Shared lookup — reused by Energy Settings (Grid Billing Account, Energy Meter Mappings).
     */
    public static readonly TREE_ENDPOINT = (id: string): string => `${UnitsConst.API_PREFIX_ENDPOINT}/tree/${id}`;

    /** GET every unit below a building as a flat list, without the building itself. */
    public static readonly LIST_ENDPOINT = (buildingId: string): string => `${UnitsConst.API_PREFIX_ENDPOINT}/list/${buildingId}`;

}
